import PropTypes from "prop-types";

export const TopbarProps = {
    disableHeader: PropTypes.bool.isRequired,
};

export const NoLocationSelectedProps = {
    initialized: PropTypes.bool.isRequired,
    setOverlayOpen: PropTypes.func.isRequired,
    setForceOverlay: PropTypes.func,
};

export const LocationSelectedProps = {
    ...NoLocationSelectedProps,
    icon: PropTypes.string.isRequired,
    address: PropTypes.string,
    storeInformation: PropTypes.object,
    isXXL: PropTypes.bool,
    fetchStoreData: PropTypes.func.isRequired,
};
